<template>
  <div class="converter-comp">
    <div class="convert-type-bar">
      <el-select v-model="convertType" size="small" placeholder="选择转换类型" style="width:200px;">
        <el-option label="Base64 编码" value="base64-encode" />
        <el-option label="Base64 解码" value="base64-decode" />
        <el-option label="URL 编码" value="url-encode" />
        <el-option label="URL 解码" value="url-decode" />
        <el-option label="Unicode 转中文" value="unicode-decode" />
        <el-option label="中文转 Unicode" value="unicode-encode" />
        <el-option label="大小写转换" value="case-toggle" />
      </el-select>
    </div>
    <div class="editor-panes">
      <div class="input-pane">
        <div class="pane-label">输入</div>
        <el-input v-model="input" type="textarea" :rows="12" placeholder="请输入内容..." class="mono-input" @input="convert" />
      </div>
      <div class="output-pane">
        <div class="pane-label">输出</div>
        <el-input v-model="output" type="textarea" :rows="12" readonly class="mono-input" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Converter',
  props: { config: { type: Object, default: () => ({}) } },
  data() {
    return { input: '', output: '', convertType: 'base64-encode' }
  },
  methods: {
    convert() {
      if (!this.input) { this.output = ''; return }
      try {
        switch (this.convertType) {
          case 'base64-encode':
            this.output = btoa(String.fromCharCode(...new TextEncoder().encode(this.input)))
            break
          case 'base64-decode':
            this.output = new TextDecoder().decode(Uint8Array.from(atob(this.input), c => c.charCodeAt(0)))
            break
          case 'url-encode':
            this.output = encodeURIComponent(this.input)
            break
          case 'url-decode':
            this.output = decodeURIComponent(this.input)
            break
          case 'unicode-decode':
            this.output = this.input.replace(/\\u[\dA-F]{4}/gi, m => String.fromCharCode(parseInt(m.replace(/\\u/g, ''), 16)))
            break
          case 'unicode-encode':
            this.output = this.input.split('').map(c => '\\u' + c.charCodeAt(0).toString(16).padStart(4, '0')).join('')
            break
          case 'case-toggle':
            this.output = this.input === this.input.toUpperCase() ? this.input.toLowerCase() : this.input.toUpperCase()
            break
          default:
            this.output = this.input
        }
      } catch (e) {
        this.output = '转换失败: ' + e.message
      }
    },
    doAction(action) {
      switch (action) {
        case 'copy':
          navigator.clipboard.writeText(this.output)
          this.$message.success(this.$t("common.status.copied"))
          break
        case 'clear':
          this.input = ''
          this.output = ''
          break
      }
    }
  },
  watch: { convertType() { this.convert() } }
}
</script>

<style scoped>
.converter-comp { }
.convert-type-bar { margin-bottom: 12px; }
.editor-panes { display: flex; gap: 16px; }
.input-pane, .output-pane { flex: 1; min-width: 0; }
.pane-label { font-size: 13px; font-weight: 600; color: #606266; margin-bottom: 8px; }
.mono-input textarea { font-family: 'Consolas', 'Monaco', monospace; font-size: 13px; }
@media (max-width: 640px) { .editor-panes { flex-direction: column; } }
</style>
